module.exports = __webpack_public_path__ + "img/banner3.2140ed35.png";